import styled from 'styled-components';

export const Show = styled.section`

    height: calc(100vh - 7rem);
    background: url("showcase-alt.jpg") no-repeat center center/cover;
    position: relative;

    &:before{
        content: "";
        background-color: ${ props => props.theme.darkColor};
        opacity: 0.7;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .container {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: relative;
        z-index: 5;

        .text-block {

            text-align: center;
            margin-bottom: 4rem;
            color: ${ props => props.theme.lightColor };

            h3 {
                font-size: 3rem;
                font-weight: 700;

                @media (max-width: 500px){

                    font-size: 2rem;

                }
            }

        }
    }


`

export const Home = styled.section`

    .section-a {

        background-color: ${ props => props.theme.lightColor };
        padding: 4rem 0;

        @media (max-width: 1024px){
            padding: 4rem 1.5rem;
        }

        .container {

            .home-intro {

                text-align: center;
                width: 50%;
                margin: 0 auto;

                h4 {
                    color: ${ props => props.theme.primaryColor };
                    font-size: 1.5rem;
                    margin-bottom: 1rem;
                    font-weight: 900;
                }

                p {
                    font-size: 1.2rem;
                    font-weight: 100;
                }

                @media (max-width: 500px){

                    width: 100%;

                    h4 {

                        font-size: 1.3rem;

                    }

                    p {
                        font-size: 1rem;
                    }

                }
            }

        }

    }

    .section-b {

        background-color: ${ props => props.theme.greyColor };
        padding: 3rem 0;

        @media (max-width: 1024px){
            padding: 3rem 1.5rem;
        }

        .container {

            .three-blocks {
                display: flex;
                justify-content: space-between;

                .block {

                    background-color: ${ props => props.theme.lightColor };
                    margin: 0.5rem;
                    padding: 2rem;
                    flex: 1;
                    text-align: center;

                    h5 {
                        font-size: 1.2rem;
                        color: ${ props => props.theme.primaryColor };
                        padding: 0.5rem 0;
                    }

                    img {
                        width: 100%;
                        height: 20rem;
                    }

                    p {
                        margin-bottom: 1.5rem;
                    }

                }

                @media (max-width: 768px){

                    flex-wrap: wrap;

                    .block {
                        
                        flex: none;
                        width: 47%;

                    }

                }

                @media (max-width: 500px){

                    .block {

                        margin: 0;
                        margin-bottom: 1rem;
                        width: 100%;

                    }


                }
            }

        }

    }

    .section-c {

        background-color: ${ props => props.theme.secondaryColor };
        padding: 3rem 0;
        
        @media (max-width: 1024px){
            padding: 3rem 1.5rem;
        }


        .container {

            h2 {
                font-size: 1.5rem;
                margin-bottom: 1rem;
                text-align: center;
            }

            .achievements {

                display: flex;
                justify-content: space-between;

                .achievement {

                    margin-right: 1rem;

                    h3 {
                        text-align: center;
                        margin-bottom: 0.5rem;
                        color: ${ props => props.theme.lightColor };
                        font-size: 0.9rem;
                    }

                    img {
                        width: 100%;
                        height: 20rem;
                    }

                }

            }

        }

        @media (max-width: 1024px){

            .container {

                .achievements {

                    flex-wrap: wrap;
                    justify-content: space-evenly;


                    .achievement {

                        margin-bottom: 1.5rem;
                        margin-right: 0;

                        h3 {

                            font-size: 1.2rem;

                        }

                        img {
                            height: 25rem;
                            width: 20rem;
                            display: block;
                            margin: auto;
                        }

                    }

                }

            }

        }

        @media (max-width: 500px){

            .container {

                .achievements {

                    .achievement {

                        margin: 0 auto 1.5rem;
                        width: 100%;

                    }

                }
            }

        }

    }

`